import listMixins from '@_system/components/base/mixins/list/list.js'
import upload from '@_system/components/formcomponents/common/upload/index.vue'
export default {
	mixins: [listMixins],
	props: {
		foreingKey: {
			type: Object,
			default: () => {
				return {}
			}
		},
		extra: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			sourcedata:[],
			device: window.systemMethods.device(),
			urlquery: [],
			reportName: '',
			windowName: '',
			windowType: 'modal',
			toolbarButtonList: this.$store.state.system.toolbarButtonList,
			operateButtonList: this.$store.state.system.operateButtonList,
			exportIds: [],
			footerField: [],
			tools: [],
			toolbarButton: [],
			operateButton: null,
			toolbarButtonConfig: [],
			operateButtonConfig: [],
			operateInrowButton: [],
			menuConfig:null,
			defaultFormValue:[],
			// defaultFormValue:[{
			// 	field:"status",
			// 	default:3
			// }],
			indexModule: {
				component: '',
				show: false,
				foreingKey: {},
				extra: {},
			},
			formModule: {
				component: '',
				name: '',
				id: 0,
				show: false,
				controlltype: 1,
				foreingKey: {},
				extra: {},
			},
			pagerConfig: {
				autoHidden: true,
				border: true,
				size: 'mini',
				perfect: false,
				currentPage: 1,
				pageSize: 20,
				pageSizes: [10, 20, 50, 100, 200, 500, 1000, 2000, 5000],
			},
			gridKey: Math.random(),
			gridOptions: null,
			editShow: false,
			formwindowShow: false,
			showFooter: false,
			tableColumn: [],
			forms: [],
			columns: []
		}
	},
	created() {
		this.toolbarButtonList = this.toolbarButtonList.concat(this.$store.state.toolbarButtons)
		this.operateButtonList = this.operateButtonList.concat(this.$store.state.operateButtons)
		this.initList()
	},
	methods: {
		preview(row) {
			this.previewformShow(row)
		},
		previewformShow(row) {
			if (this.windowType == 'window') {
				let res = this.$router.resolve({
					name: 'add',
					query: {
						name: this.reportName,
						id: row.id,
						controlltype: 3,
						windowName: '编辑' + this.windowName,
					}
				})
				let win = window.open(res.href, this.reportName + 'edit',
					"toolbar=no,width=1600,height=900,resizable=no")
				win.onload = () => {

				}
			} else {
				this.formModule = {
					name: this.reportName,
					id: row.id,
					controlltype: 3,
					windowName: '编辑' + this.windowName,
					foreingKey: {},
					extra: {}
				}
				this.formwindowShow = true
			}
		},


		initToolbarButton() {
			let buttons = []
			let groups = []
			let tools = []

			//let dropdowns = []
			if (this.toolbarButtonConfig) {
				this.toolbarButtonConfig.forEach((item) => {
					this.toolbarButtonList.forEach((button) => {
						if (button.code == item) {
							if (button.tools) {
								let tbutton = JSON.parse(JSON.stringify(button))
								tbutton.name = ''
								tools.push(tbutton)
							} else {
								if (item != 'exportcurrent' && item != 'exportall') {
									if (!button.group) {
										buttons.push(button)
									} else {
										if (!groups[button.group.name]) {
											groups[button.group.name] = {
												groupconfig: button.group,
												buttons: [],
											}
										}
										button.type = 'text'
										button.status = ''
										groups[button.group.name].buttons.push(button)
									}
								}


							}
						}
					})
				})
				for (let i in groups) {
					buttons.push({
						name: i,
						status: groups[i].groupconfig.status,
						dropdowns: groups[i].buttons
					})
				}
			}
			this.toolbarButton = buttons
			this.tools = tools
		},

		initOperateButton() {
			let buttons = []
			if (this.operateButtonConfig) {
				this.operateButtonConfig.forEach((item) => {
					this.operateButtonList.forEach((button) => {
						if (button.code == item) {
							buttons.push(button)
						}
					})
				})
			}
			buttons.forEach((item) => {
				let buff = !!item.inrow
				if (buff) {
					this.operateInrowButton.push(item)
				}
			})

			this.operateButton = {
				bind: this,
				name: '$operateButton',
				buttons: buttons
			}
		},
		initList() {
			//console.log(this.reportName)
			this.$api.report.reportconfig(this.reportName).then((res) => {
				this.toolbarButtonConfig = res.toolbarButtonConfig
				this.operateButtonConfig = res.operateButtonConfig
				this.columns = res.columns
				this.forms = res.forms
				this.initToolbarButton()
				this.initOperateButton()
				this.initOption()
				if (this.afterCreateGrid) {
					this.afterCreateGrid()
				}
			})
		},
		initOption(){
				let gridOptions = this.getOption()
				gridOptions.id = this.moduleName + '_listreport',
				gridOptions.proxyConfig.autoLoad = this.autoLoad
				gridOptions.cellStyle = this.cellStyle
				gridOptions.menuConfig = this.menuConfig	
				gridOptions.pagerConfig = this.pagerConfig		
				gridOptions.toolbarConfig =  {
					size: 'mini',
					perfect: false,
					buttons: this.toolbarButton,
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					tools: this.tools
				}
				gridOptions.tooltipConfig = {
					showAll: true,
					enterable: true,
					contentMethod: this.tipcontentMethod
				},
				gridOptions.treeConfig = {
					lazy: true,
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: false,
					loadMethod: this.loadMethod
				}
				gridOptions.importConfig = {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod: this.importMethod ? this.importMethod : this.import
				}
				gridOptions.exportConfig = {
					type: 'xlsx',
					types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
					remote: true,
					exportMethod: this.exportMethod ? this.exportMethod : this.export
				}
				gridOptions.columns = this.getColumns(this.columns)
				gridOptions.formConfig = this.getForm(this.columns)
				gridOptions.checkboxConfig = {
					labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
				}
				gridOptions.radioConfig = {
					labelField: gridOptions.columns[0] ? gridOptions.columns[0].field : '',
				}
				if (this.beforeCreateGrid) {
					this.beforeCreateGrid(gridOptions.formConfig, gridOptions.columns, gridOptions)
				}
				this.gridOptions = gridOptions
		},
		getOption() {
			let list_getOption = this.list_getOption()
			this.list_gridOptions = list_getOption
			return list_getOption
		},
		list(page,updateForm,other) {
			return new Promise(resolve => {
				this.$api.report.reportlist(this.reportName,{
					...page,
					...updateForm,
					...other,
					...this.foreingKey
				}).then((res) => {
					this.sourcedata = JSON.parse(JSON.stringify(res.list))
					if (this.afterGet) {
						this.afterGet(res,updateForm)
					}
					resolve(res)
				}, () => {
					resolve([])
				})
			})
		},
		getForm(data) {
			let items = []
			data.forEach((item) => {
				if (item.render) {
					let hasDefault = this.defaultFormValue.find((defaultitem)=>{
						return defaultitem.field == item.field
					})
					let obj = {
						titleOverflow: true,
						field: item.field,
						title: item.title,
						folding: items.length >= 3,
						span: 4,
						resetValue:hasDefault?hasDefault.default:null,
						// span: item.field.match(/.*time$/g) && (item.props.type == 'datetimerange' || !item
						// 	.props.type) ? 8 : 4,
						itemRender: {
							name: item.render,
							defaultValue:hasDefault?hasDefault.default:null,
							options: [],
							optionProps: {

							},
							props: {
								islist: true,
								name: item.name,
								size: 'mini',
								placeholder: '',
								...item.props
							},
						},
					}
					// let param = this.getQueryParam(item.field)
					// if (param) {
					// 	if (item.field.match(/.*time$/g)) {
					// 		if (this.device == 'pc') {
					// 			param = param.split(',')
					// 			param.forEach((item, index) => {
					// 				param[index] = item * 1000
					// 			})
					// 		}
					// 	}
					// 	obj.itemRender.defaultValue = param
					// }

					items.push(obj)
				}
			})
			if (items.length != 0) {
				items.push({
					align: 'left',
					span: 24,
					itemRender: {
						name: '$tableformbutton'
					}
				})
				// items.push({
				// 	align: 'left',
				// 	span: 24,
				// 	// collapseNode: items.length > 3,
				// 	itemRender: {
				// 		name: '$buttons',
				// 		children: [{
				// 			props: {
				// 				type: 'submit',
				// 				content: '查询',
				// 				status: 'primary'
				// 			}
				// 		}, {
				// 			props: {
				// 				type: 'reset',
				// 				content: '重置'
				// 			}
				// 		}]
				// 	}
				// })
			}
			return {
				titleOverflow:true,
				titleWidth: '60',
				titleAlign: 'center',
				items: items,
				span: 6
			}
		},
		getColumns(data) {
			let columns = []
			// columns.push({
			// 	width:80,
			// 	fixed:'left',
			// 	title:'#',
			// 	type:'seq'
			// })
			//console.log(data)
			data.forEach((item) => {
				if (item.props.show!==false) {
					this.tableColumn.push({
						field: item.field,
						title: item.title,
					})
				}
				let slots = {}
				if(item.type == 'expand'){
					slots.content = ({row})=>{
						let str = []
						row[item.field].forEach((_item) => {
							str.push( <div style = "margin:20px" > {_item.name + '（' + _item.code + '）'} </div>)
						})
						return str
					}
				}
				if(item.formatter == 'file'){
					slots.default = ({row})=>{
						if(row[item.field]){
							return <upload value={row[item.field]} readonly />
						}
						return null
					}
				}
				let obj = {
					field: item.field,
					title: item.title,
					fixed: item.fixed ? item.fixed : null,
					showHeaderOverflow:'tooltip',
					sortable: item.sortable,
					minWidth: item.width ? item.width : 'auto',
					type: item.type ? item.type : null,
					slots:slots,
					// slots: item.type == 'expand' ? {
					// 	content: ({
					// 		row
					// 	}) => {
					// 		let str = []
					// 		row[item.field].forEach((_item) => {
					// 			str.push( <
					// 				div style = "margin:20px" > {
					// 					_item.name + '（' + _item.code + '）'
					// 				} < /div>
					// 			)
					// 		})
					// 		return str
					// 	}
					// } : null,
					formatter: (item.formatter && item.formatter!='file') ? ({
						row
					}) => {
						return window.systemMethods.formatter(row, item)					
					} : null,
					visible: item.props.show,
					treeNode: item.treeNode,
				}
				if (item.props && item.props.selectoptions && item.props.selectoptions.length != 0) {
					obj.formatter = ({
						row
					}) => {
						let options = item.props.selectoptions.find((opv) => {
							return opv.value == row[item.field]
						})

						return options ? options.label : null
					}
				}
				if (item.props) {
					if (item.props.penetrate) {
						obj.editRender = {
							name: '$quote',
							props: item.props,
							events: {}
						}
					}
					if (item.props.flowstatus) {
						obj.editRender = {
							name: '$flowstatus',
							props: item.props,
							events: {}
						}
					}
					if (item.props.auditorstaffid) {
						obj.editRender = {
							name: '$auditorstaffid',
							props: item.props,
							events: {}
						}
					}
					if (item.props.copycontent && !obj.editRender && !obj.slots) {
						obj.slots = {
							default: ({
								row,
								column
							}) => {
								return <div>
										<i style ="margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {() => {this.copycontent(column, row)}} class = "el-icon-document-copy" > </i> 
										<span> {row[column.field]} </span> 
									</div>
							},
							header: ({
								column
							}) => {
								return <div>
										<i style = "margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {() => {this.copycontent(column, null)}} class = "el-icon-document-copy" > </i> 
										<span> {column.title} </span> 
									</div>
							}
						}
					}
				}


				columns.push(obj)

			})

			if (data.length != 0 && this.operateButtonConfig.length != 0) {
				columns.push({
					field: '',
					title: '操作',
					width: (this.operateInrowButton.length == this.operateButtonConfig.length ? this
						.operateInrowButton.length : this.operateInrowButton.length + 1) * 65,
					fixed: "right",
					align: 'center',
					visible: Boolean(this.operateButtonConfig.length),
					cellRender: this.operateButton
				})
			}
			return columns
		},
		toolbarButtonClickEvent(e, execute = true) {
			return new Promise((resolve, reject) => {
				this.$api.report.reportconfig(this.reportName).then((res) => {
					let toolbarButtonConfig = res.toolbarButtonConfig
					let index = toolbarButtonConfig.findIndex((item) => {
						return item == e.code
					})
					if (index !== -1) {
						if (execute) {
							this[e.code]()
						}
						resolve()
					} else {
						this.$message.error('暂无操作权限')
						reject()
					}
				})
			})
		},
		operateButtonClickEvent(e) {
			this.$api.report.reportconfig(this.reportName).then((res) => {
				let operateButtonConfig = res.operateButtonConfig
				let index = operateButtonConfig.findIndex((item) => {
					return item == e.code
				})
				if (index !== -1) {
					this[e.code](e.data)
				} else {
					this.$message.error('暂无操作权限')
				}
			})
		},
		tipcontentMethod() {
		
		},
		getGrid(){
			return this.$refs[this.reportName+'_list']
		},
		copycontent(column, row) {
			if (row) {
				if(row[column.field]){
					this.$copyText(row[column.field]).then(() => {
						this.$message.success('复制成功')
					}, () => {
						this.$message.success('复制失败')
					})
				}else{
					this.$message.error('无可复制内容')
				}
			} else {
				let fullData = this.$refs[this.reportName+'_list'].getTableData().fullData
				let content = []
				fullData.forEach((item) => {
					if(item[column.field]){
						content.push(item[column.field])
					}	
				})
				this.$copyText(content.join('\n')).then(() => {
					this.$message.success('复制成功')
				}, () => {
					this.$message.success('复制失败')
				})
		
			}
		},
		// toolbarButtonClickEvent(e) {

		// 	this.$api.report.reportconfig(this.reportName).then((res) => {
		// 		let toolbarButtonConfig = res.toolbarButtonConfig
		// 		let index = toolbarButtonConfig.findIndex((item) => {
		// 			return item == e.code
		// 		})
		// 		if (index !== -1) {
		// 			this[e.code]()
		// 		} else {
		// 			this.$message.error('暂无操作权限')
		// 		}
		// 	})
		// },
		formBack(e) {
			this.formwindowShow = false
			this.formModule = {
				component: '',
				name: '',
				id: 0,
				show: false,
				controlltype: 1,
				extra: {},
				foreingKey: {},
			}
			if (e.type != 'cancle') {
				this.customreload()
			}
		},
		footerMethod({
			columns,
			data
		}) {
			let footData = []
			columns.forEach((item) => {
				let obj = this.footerField.find((obj) => {
					return obj.field == item.field
				})
				if (obj) {
					if (obj.type == 'seq') {
						footData.push(obj.title)
					} else {
						footData.push(this.sum(item.field, data, obj.toFixed))
					}

				} else {
					footData.push('')
				}

			})
			return [
				footData
			]
		},
		sum(field, data, toFixed) {
			let sum = 0
			data.forEach((item) => {

				for (let i in item) {
					if (i == field) {
						sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
					}
				}
			})
			return sum.toFixed(toFixed)
		},
		footerCellClassName() {
			return 'footerCellColor'
		},
		reload() {

		},
		customreload() {
			if (this.$refs[this.reportName + '_list']) {
				this.$refs[this.reportName + '_list'].commitProxy('query')
			}

		},
		getQueryParam(param) {
			// 获取当前URL
			let url = window.location.href;

			// 查找问号的位置
			let queryStart = url.indexOf("?");
			if (queryStart === -1) return null; // 如果没有问号，返回null

			// 截取查询字符串部分
			let queryString = url.substring(queryStart + 1);

			// 创建URLSearchParams对象
			let params = new URLSearchParams(queryString);

			// 获取指定参数值
			return params.get(param);
		},
		del() {

		},
		cellStyle() {

		},
		exportpanel() {
			this.$refs[this.exportRef].exportNoticeShow = true
		},
		loadMethod() {

		},
		spanMethod() {

		},
		afterexport() {

		},
		cellClick(){
			
		}
	},
}